import axios from 'axios';

// '/provider_practices/' + this.providerPracticeId +  '/provider_practice_programs/'

export const loadProviderPracticePrograms = providerPracticeId => (
	axios.get(`/provider_practices/${providerPracticeId}/provider_practice_programs`)
);

export const addProviderPracticeProgram = program => (
    axios.post(`/provider_practices/${program.providerPracticeId}/provider_practice_programs`, program)
);

export const updateProviderPracticeProgram = program => (
    axios.put(`/provider_practices/${program.providerPracticeId}/provider_practice_programs/${program.id}`, program)
);

export const deleteProviderPracticeProgram = ({ providerId, ...rest }) => (
	// axios.delete(`/provider_practices/${providerPracticeId}/provider_practice_programs/${id}`)
    axios.post(`/providers/${providerId}/delete-provider-practice-program`, { ...rest })
);
